import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import styles from './LayerOptions.styles';
import Grid from '@material-ui/core/Grid';
import SubAreaSelect from '../SubAreaSelect';
import SubAreaOptions from '../SubAreaOptions';
import SubAreaDataEntry from '../SubAreaDataEntry';

const useStyles = makeStyles(styles);

/**
 * @function components/LayerOptions
 * @description Rendered by both the menu and dialog, this component renders the options available for the layer type.
 * @param {Object} layer - The layer class created after a shape is drawn on a map
 * @example
 * <LayerOptions
 *  layer={layer}
 * />
 */
const LayerOptions = ({  layer }) => {
  const classes = useStyles();
  const { id, layerOption  } = layer;

  if(layerOption && layerOption.subArea && layerOption.subArea.length){
    return (
      <Grid container>
        <Grid item xs={12}>
          <SubAreaSelect layer={layer}/>
        </Grid>
      </Grid>
    )
    return 
  }
  return null;
};

LayerOptions.propTypes = {
  layer: PropTypes.object,
};

export default LayerOptions;
